"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleTrimDeserialize = void 0;
const ValidationResult_1 = require("../type-descriptions/ValidationResult");
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const TransportType_1 = require("./TransportType");
function vehicleTrimDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        fuelVehicleId: (0, deserializeString_1.deserializeString)(object.fuelVehicleId),
        make: (0, deserializeString_1.deserializeString)(object.make),
        model: (0, deserializeString_1.deserializeString)(object.model),
        name: (0, deserializeString_1.deserializeString)(object.name),
        transportType: (0, ValidationResult_1.validationResultCheck)(TransportType_1.transportTypeDescription.validate(object.transportType)),
        year: (0, deserializeNumber_1.deserializeNumber)(object.year),
    };
}
exports.vehicleTrimDeserialize = vehicleTrimDeserialize;
